<template>
    <div>
        <v-row>
            <label for="username" style="display:none">Username</label>
            <input type="text" name="username" style="display:none">
            <label for="password" style="display:none">Password</label>
            <input type="password" name="password" style="display:none">
        </v-row>

        <v-row>
            <AppFormInput label="Email" required>
                <AppTextField 
                    name="auth_email" disabled :autocomplete="false" :value="username" 
                />
            </AppFormInput>
        </v-row>

        <v-row>
            <AppFormInput label="Password" required>
                <AppTextField 
                    name="auth_password" type="password" :autocomplete="false"
                    v-model="form.model.password" 
                />
            </AppFormInput>
        </v-row>

         <v-row>
            <AppFormInput label="2FA Code" required>
                <AppTextField 
                    name="auth_code" :autocomplete="false" 
                    v-model="form.model.code"
                />
            </AppFormInput>
        </v-row>

        <v-row>
            <AppErrorList :errors="form.errors" />
        </v-row>

        <v-row class="form-button-row">
            <AppButton 
                class="success-button" colour="success" text="Login"
                :disabled="form.lockBtn === true"
                @click="attemptLogin" 
            />
        </v-row>
    </div>
</template>
<script>

    import AuthService from "@coreService/user/Auth.service";
    import AuthMixin from "@coreMixin/auth/Auth.mixin.js";

    export default {

        mixins: [ AuthMixin ],

        props: {

            username: {
                type: String
            }

        },

        data () {
            return {
                form: {
                    model: {
                        password: "",
                        code: ""
                    },
                    lockBtn: false,
                    errors: []
                }
            };
        },

        mounted () {
            this.deleteAuth();
        },

        methods: {

            async attemptLogin () {
                this.form.errors = [];
                this.form.lockBtn = true;

                const   authService = new AuthService(this);
                const   httpRes = await authService.auth(this.username, this.form.model.password, this.form.model.code),
                        data = httpRes.getData();

                if(httpRes.hasErrors() === true) {
                    this.form.errors = httpRes.getErrors();
                    this.$toasted.error("Failed to login");
                    this.form.lockBtn = false;
                    return;
                }

                this.form.lockBtn = false;
                this.setAuthToken(data.account_auth_token);
                this.$router.push({name: 'dashboard'});
            }

        }

    }
</script>